import { Component, OnInit, Inject, Renderer2, ElementRef, ViewChild, HostListener } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import 'rxjs/add/operator/filter';
import { DOCUMENT } from '@angular/common';
import { LocationStrategy, PlatformLocation, Location } from '@angular/common';
import { UsuarioService } from './services/usuario/usuario.service';
import { RolesService } from './services/roles/roles.service';
import { MatSidenav } from '@angular/material/sidenav';

var didScroll;
var lastScrollTop = 0;
var delta = 5;
var navbarHeight = 0;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    private _router: Subscription;
    mostrar = false;
    rid = '';
    @ViewChild('sidenav') sidenav: MatSidenav;
    
    
    constructor( private renderer : Renderer2, public router: Router, @Inject(DOCUMENT,) private document: any, private element : ElementRef, public location: Location,
            private usuarioService: UsuarioService,
            private roleService: RolesService) {}
    @HostListener('window:scroll', ['$event'])
    hasScrolled() {

        var st = window.pageYOffset;
        // Make sure they scroll more than delta
        if(Math.abs(lastScrollTop - st) <= delta)
            return;

        var navbar = document.getElementsByTagName('nav')[0];

        // If they scrolled down and are past the navbar, add class .headroom--unpinned.
        // This is necessary so you never see what is "behind" the navbar.
        if (st > lastScrollTop && st > navbarHeight){
            // Scroll Down
            if (navbar.classList.contains('headroom--pinned')) {
                navbar.classList.remove('headroom--pinned');
                navbar.classList.add('headroom--unpinned');
            }
            // $('.navbar.headroom--pinned').removeClass('headroom--pinned').addClass('headroom--unpinned');
        } else {
            // Scroll Up
            //  $(window).height()
            if(st + window.innerHeight < document.body.scrollHeight) {
                // $('.navbar.headroom--unpinned').removeClass('headroom--unpinned').addClass('headroom--pinned');
                if (navbar.classList.contains('headroom--unpinned')) {
                    navbar.classList.remove('headroom--unpinned');
                    navbar.classList.add('headroom--pinned');
                }
            }
        }

        lastScrollTop = st;
    };
    ngOnInit() {
        this.rid = localStorage.getItem('rid');
        if(this.usuarioService.estaLogueado()){
            this.rid = localStorage.getItem('rid');
            this.usuarioService.getrol(this.rid).subscribe( resp => {
              if(resp['data'].attributes.name === 'SuperAdmin' || resp['data'].attributes.name === 'Vendedor'){
                  this.mostrar = true;
              }              
          })
        }

      var navbarEl = this.element.nativeElement.children[0] ? this.element.nativeElement.children[0].children[0] : null;
      this._router = this.router.events.filter(event => event instanceof NavigationEnd).subscribe((event: NavigationEnd) => {
          if (window.outerWidth > 991) {
              window.document.children[0].scrollTop = 0;
          }else{
              window.document.activeElement.scrollTop = 0;
          }
          if (navbarEl) {
            this.renderer.listen('window', 'scroll', (event) => {
                const number = window.scrollY;
                if (number > 150 || window.pageYOffset > 150) {
                    // add logic
                    navbarEl.classList.add('headroom--not-top');
                } else {
                    // remove logic
                    navbarEl.classList.remove('headroom--not-top');
                }
            });
          }
      });
      this.hasScrolled();
    }

    ngOnDestroy(): void {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        localStorage.clear();
    }
}
